export const GET_CREATE_GROUP = 'GET_CREATE_GROUP';
export const SET_CREATE_GROUP = 'SET_CREATE_GROUP';

export const GET_DELETE_GROUP = 'GET_DELETE_GROUP';
export const SET_DELETE_GROUP = 'SET_DELETE_GROUP';
GET_DELETE_GROUP;

export const SET_EVALUATION_GROUP = 'SET_EVALUATION_GROUP';
export const SET_EVALUATION_GROUP_DELETE = 'SET_EVALUATION_GROUP_DELETE';
